import { useCallback } from 'react';
import { CellValueChangedEvent } from 'ag-grid-community';
import { EQM3010_R01Dto } from '../Dto_EQM3010_R01';

interface Props {
	EQM3010_R01List: EQM3010_R01Dto[];
	updateEQM3010_R01List: (index: number, data: EQM3010_R01Dto) => void;
}

export function useEQM3010_R01CellChange({ EQM3010_R01List, updateEQM3010_R01List }: Props) {
	const handleCellChange = useCallback((e: CellValueChangedEvent<EQM3010_R01Dto>) => {
		if (e.newValue === e.oldValue) return;
		const field = e.colDef.field;
		if (!field || !e.data) return;
		const row = EQM3010_R01List.find((r) => r.valueIndex === e.data!.valueIndex);
		if (!row) return;
		updateEQM3010_R01List(row.valueIndex, {
			...row,
			[field]: e.newValue ?? '',
			isModified: true,
		});
	}, [EQM3010_R01List, updateEQM3010_R01List]);

	return { handleCellChange };
}
